import type { FC } from "react";

import { IconButton } from "@similarweb/ui-components";

import type { ICompanyItem } from "app/@types/autocomplete";

import {
    CompanyInfoContainer,
    CompanyName,
    CompanySubTitle,
    ItemIconContainer,
    CompanyItemContainer,
    StyledCompanyLegendContainer,
} from "./style";

type Props = {
    iconSrc?: string;
    companyInfo: ICompanyItem;
    domains: readonly string[];
    onClick(name: string): void;
};

const CompanyListItem: FC<Props> = ({ domains, iconSrc, onClick, companyInfo }) => {
    return (
        <CompanyItemContainer>
            <StyledCompanyLegendContainer>
                {iconSrc ? <ItemIconContainer iconSrc={iconSrc} /> : null}
                <CompanyInfoContainer>
                    <CompanyName>{companyInfo.companyName}</CompanyName>
                    {domains.length > 0 ? <CompanySubTitle>{domains.join(", ")}</CompanySubTitle> : null}
                </CompanyInfoContainer>
            </StyledCompanyLegendContainer>

            <IconButton
                iconSize="xs"
                iconName="clear"
                type="flat"
                onClick={() => onClick(companyInfo.companyName)}
            />
        </CompanyItemContainer>
    );
};

export default CompanyListItem;
